module.exports = __webpack_public_path__ + "static/media/starlla3.3afc1397.jpg";